import gql from 'graphql-tag';

const QUERY_STATIC_GOOGLE_MAP = gql`
    query googleMap($staticGoogleMapUrls: [String!]!) {
        googleMapUrlSignatures(urls: $staticGoogleMapUrls)
    }
`;

export default QUERY_STATIC_GOOGLE_MAP;
